import { Subject } from 'rxjs';
import { ResultDataSource } from './result-data-source';
import { FilterParams } from '../models/filter-params';
import { BaseCrudService } from '../services/base-crud.service';
import { ConfirmDialogService } from '../services/confirm-dialog-service.service';
import { NotificationService } from '../services/notification.service';
import { inject } from '@angular/core';
import { NotificationMessages, NotificationType } from '../models/notification';
import { Identifiable } from '@t-llevo/util';

export abstract class BaseListItems<T extends Identifiable, R> {
  dataSource: ResultDataSource<T, R>;
  searchParam = '';
  activeFilter: FilterParams | null = null;
  stop$ = new Subject<boolean>();

  confirmDialogSrv = inject(ConfirmDialogService);
  notifySrv = inject(NotificationService);
  constructor(public crudSrv: BaseCrudService<T, R>, public schemaUrl: string) {
    this.dataSource = new ResultDataSource<T, R>(this.crudSrv);
  }

  delete(item: T, bodyTxt?: string): void {
    const config = {
      title: `¿Desea eliminar el elemento?`,
      message: bodyTxt ?? 'El elemento se eliminará de forma permanente',
      cancelText: 'CANCELAR',
      confirmText: 'SI, DESEO ELIMINAR',
    };
    this.confirmDialogSrv.open(config).subscribe((dataDialog) => {
      if (dataDialog)
        this.crudSrv.deleteItem(this.schemaUrl, item.id).subscribe({
          next: () => {
            this.notifySrv.dispatch(
              NotificationMessages.DeleteSuccess,
              NotificationType.success
            );
            this.loadItems(this._getFiltersParams());
          },
          error: (error) => {
            this.notifySrv.dispatch(
              NotificationMessages.DeleteError,
              NotificationType.error
            );
            console.error(error);
          },
        });
    });
  }

  loadItems(filters: FilterParams = {}, url?: string | null) {
    // URL TO GET DATA
    const urlRequest = url ? url : this.schemaUrl;
    // GET FILTER DATA
    this.dataSource.filterParams = { ...filters };
    // GET DATA FROM DATASOURCE
    this.dataSource.loadData(urlRequest);
  }

  abstract _getFiltersParams(defaultField?: string): FilterParams;

  onSearch(ev: string): void {
    if (this.searchParam !== ev) {
      this.searchParam = ev;
      this.loadItems(this._getFiltersParams());
    }
  }

  trackById(index: number, elem: T) {
    return elem ? elem.id : undefined;
  }
}
